import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ContactCard from "../../../../molecules/contact/contact-card";
import { contactData, getAllContactsAPI } from "../types";
import NoResultFoundFilters from "../../../../atoms/noResultsFilters";
import CardsLoadingScreen from "../../../../atoms/cardsLoader";
import PaginationComponent from "../../../../atoms/pagination";

type Props = {
  apiData: getAllContactsAPI | null;
  isFilter: boolean;
  openEditContact: (id: number) => void;
  page: number;
  totalPages: number;
  totalResult: number;
  paginationHandler: (event: React.ChangeEvent<unknown>, page: number) => void;
  dropdownFilterProps?: {
    link: string;
    setFilterPayload(page: string): void;
    dropDownItems: { label: React.ReactNode; value: string }[];
    filterValue: string;
  };

};

const ContactCards = ({ apiData, isFilter, openEditContact, page,
  totalPages,
  totalResult,
  paginationHandler,
  dropdownFilterProps }: Props) => {

  const actualListArray = Array.isArray(apiData) ? apiData : apiData?.data
  return (
    <>
      {(apiData?.success || (actualListArray?.length)) ? (
        <>
          {actualListArray?.length ? (
            <>
              <Grid container spacing={2}>
                {(apiData?.data || actualListArray)?.map((data: contactData, index) => {
                  return (
                    <Grid key={data.id || index} item xs={12} md={6} lg={4}>
                      <ContactCard data={data} openEditContact={openEditContact} />
                    </Grid>
                  )
                })}
              </Grid>
              <PaginationComponent
                page={page}
                totalPages={totalPages}
                totalResult={totalResult}
                paginationHandler={paginationHandler}
                dropdownFilterProps={dropdownFilterProps} /></>
          ) : (
            <>
              {!isFilter ? (
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    mt={4}
                  >
                    <Typography
                      variant="h2"
                      sx={{ fontSize: "20px", fontWeight: "500" }}
                    >
                      No Client Contacts Found
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <NoResultFoundFilters />
              )}
            </>
          )}
        </>
      ) : (
        <CardsLoadingScreen />
      )}
    </>
  );
};

export default ContactCards;
